import api from './api';

export interface TuttiPermission {
  key: string;
  featureKey: string;
  action: 'read' | 'write';
  description: string;
  createdAtUnixMs: string;
  updatedAtUnixMs: string;
}
export interface TuttiPermissionPage {
  permissions: TuttiPermission[];
  nextKey: string;
  requiredPermissions: TuttiPermission[];
}
const path = '/api/v1/admin/tutti-permissions';
export const tuttiPermissionsApi = {
  list: (afterKey = '') =>
    api.get<unknown, TuttiPermissionPage>(path, {
      params: { afterKey, pageSize: 50 },
    }),
  register: (
    permission: Pick<
      TuttiPermission,
      'key' | 'featureKey' | 'action' | 'description'
    >,
  ) =>
    api.post<unknown, { permission: TuttiPermission }>(
      `${path}/register`,
      permission,
    ),
  update: (key: string, description: string, expectedDescription: string) =>
    api.post<unknown, { permission: TuttiPermission }>(`${path}/update`, {
      key,
      description,
      expectedDescription,
    }),
  registerRequired: () => api.post(`${path}/register-required`, {}),
};
